import React, {Component} from "react";
import BlockSearch from "./BlockSearch";

class BlockDatargrid extends Component {
    constructor(props) {
        super(props);
    }

    buildRows() {
        let rows = [];
        for (let i = 0; i < this.props.block.results; i++) {
            let cols = [];
            this.props.block.blockItems.map(blockItem => {
                if (blockItem.type === 13) {
                    cols.push(
                        <td className="corAttr-hide">
                            <input type="hidden"
                                   className="coreAttr-datagridLineInput"
                                   name={"TEMP_PARAM_" + "BLOCK_ITEM_" + blockItem.id[i]}
                                   value={blockItem.values[i]}/>
                        </td>
                    );
                } else if (blockItem.type === 12) {
                    cols.push(
                        <td className={blockItem.columnClass} dangerouslySetInnerHTML={{__html: blockItem.labels[i]}}></td>
                    );
                } else {
                    cols.push(
                        <td className={blockItem.columnClass} dangerouslySetInnerHTML={{__html: blockItem.values[i]}} style={JSON.parse(blockItem.inputCss)}></td>
                    );
                }
            });
            rows.push(<tr id={"BLOCK_ID_" + this.props.block.id + "_MASTER_TABLE_ID_" + this.props.block.masterTable}
                                     className={this.props.block.classLines[i]}
                                     onClick={(e) => this.onClick(e, this.props.block.onClickLines[i])}>{cols}</tr>)
        }
        return rows;
    }
    onClick(e, action) {
        let regex = /@click=.+/;
        if (regex.test(action)) {
            this.props.externalCall(regex.exec(action)[0].split("=")[1]);
        } else {
            eval(action);
        }
    }

    getComponent(block) {
        switch (block.view) {
            default : return BlockSearch;
        }
        return null;
    }

    render() {
        const rows = this.buildRows();
        return (
            <div id={"BLOCK_" + this.props.block.id} className="coreBlockDatagrid">

                {this.props.block.blockLinks && this.props.block.blockLinks.map(blockLink => {
                    const ComponentName = this.getComponent(blockLink);
                    return (
                        <div className={blockLink.class}>
                            <ComponentName
                                block={blockLink}
                                onChange={this.props.onChange}
                                externalCall={this.props.externalCall}
                                primaryKey={this.props.primaryKey}/>
                        </div>
                    );
                })}

                <div className="coreBlockDatagrid-result">
                    <table id={"MASTER_TABLE_" + this.props.block.masterTable}
                           className={"coreTable " + (this.props.block.isOnClickLine ? "coreAttr-selectable" : "")}>
                        <thead>
                        <tr>
                            {this.props.block.blockItems.map(blockItem => {
                                if (blockItem.type !== 13) {
                                    return (
                                        <th id={"DATAGRID_ORDER_" + this.props.block.id + "_" + blockItem.id}
                                            className={!blockItem.isDisplayColumn && "corAttr-hide"}
                                            onClick={e => this.props.onChangeOrder(this.props.block.id, blockItem.id, this.props.block.order == blockItem.id ? !this.props.block.isAscending : true)}>
                                            {blockItem.type === 12 ? blockItem.label2 : blockItem.label}
                                        </th>
                                    )
                                }
                            })}
                        </tr>
                        </thead>
                        <tbody>
                            {rows}
                        </tbody>
                    </table>

                    <div className="corePager">
                        <div className="corePager-total">Résultats : <span>{this.props.block.count}</span></div>
                        {this.props.block.pageSize > 0 &&
                            <div className="corePagerNav">
                                {this.props.block.pageIndex > 1 &&
                                    <React.Fragment>
                                        <div className="corePagerNav-firstPage" onClick={e => this.props.onChangePage(this.props.block.id, 1)} title="Première page"></div>
                                        <div className="corePagerNav-prevPage" onClick={e => this.props.onChangePage(this.props.block.id, this.props.block.pageIndex - 1)} title="Page précédente"></div>
                                    </React.Fragment>
                                }
                                <div className="corePagerNav-currentPage">Page <span>{this.props.block.pageIndex}</span> sur {this.props.block.pageCount}</div>
                                {this.props.block.pageIndex < this.props.block.pageCount &&
                                    <React.Fragment>
                                        <div className="corePagerNav-nextPage" onClick={e => this.props.onChangePage(this.props.block.id, this.props.block.pageIndex + 1)} title="Page suivante"></div>
                                        <div className="corePagerNav-lastPage" onClick={e => this.props.onChangePage(this.props.block.id, this.props.block.pageCount)} title="Dernière page"></div>
                                    </React.Fragment>
                                }
                            </div>
                        }
                    </div>

                </div>
            </div>
        )
    }
}

export default BlockDatargrid;